import React from "react";
import { useTranslation } from "react-i18next";
import {
    DetailsBlock,
    DetailsHeader,
    DetailsRow,
    Label,
    Value,
} from "src/components/ContinueDealerOffer/Pages/ReviewPage";

interface Props {
    firstName?: string;
    lastName?: string;
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string | null;
}

const CustomerInformation = ({ firstName, lastName, address, address2, city, state, zip }: Props) => {
    const { t } = useTranslation();

    return (
        <DetailsBlock>
            <DetailsHeader>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.Header")}</DetailsHeader>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.FirstName")}</Label>
                <Value>{firstName}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.LastName")}</Label>
                <Value>{lastName}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.AddressLine1")}</Label>
                <Value>{address}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.AddressLine2")}</Label>
                <Value>{address2}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.City")}</Label>
                <Value>{city}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.State")}</Label>
                <Value>{state}</Value>
            </DetailsRow>
            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.CustomerInformation.ZipCode")}</Label>
                <Value>{zip}</Value>
            </DetailsRow>
        </DetailsBlock>
    );
};

export default CustomerInformation;
